import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { UsefulLink } from 'app/models/useful-link';
import { ModalUsefulLinkComponent } from 'app/shared/components/modal-useful-link/modal-useful-link.component';

@Component({
  selector: 'app-useful-link-asset',
  templateUrl: './useful-link-asset.component.html',
  styleUrls: ['./useful-link-asset.component.scss']
})
export class UsefulLinkAssetComponent implements OnInit {

  @Input() usefulLink: UsefulLink;
  @Output() edit: EventEmitter<UsefulLink> = new EventEmitter();
  @Output() delete: EventEmitter<UsefulLink> = new EventEmitter();
  bsModalRef: BsModalRef;

  constructor(private modalService: BsModalService) {}

  ngOnInit() { }

  onDelete() {
    this.delete.emit(this.usefulLink);
  }

  onEdit() {
    event.stopPropagation();
    this.edit.emit(this.usefulLink);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/useful-link-asset/useful-link-asset.component.ts